import React from "react";
import { useTranslation } from "react-i18next";

export default function AccountPageHeader() {
  const [t] = useTranslation();

  return (
    <div className="mb-4">
      <h1 className="text-2xl font-bold">{t("admin.nav.accounts")}</h1>
    </div>
  );
}
